/*
 * ROST ZAUN - gemeinsame Warenkorb-Logik
 *
 * Drei Aufgaben:
 *  1. Mini-Warenkorb: seitliches Fenster, das sich nach "In den Warenkorb" öffnet
 *     und den Korbinhalt mit Summe und Kasse-Knopf zeigt (window.RostKorb.oeffnen()).
 *  2. Warenkorb-Seite: minus/plus je Position über /cart/change.js. Schlüssel ist
 *     item.key, nicht die Zeilennummer - die verschiebt sich beim Entfernen.
 *  3. Zähler im Kopfbereich aktuell halten (mit kurzer Hüpf-Animation).
 *
 * Beträge kommen von Shopify in Cent, Ausgabe geteilt durch 100 (Hauskonvention).
 * Ohne JavaScript bleibt alles benutzbar: Formular mit updates[], Entfernen-Links.
 *
 * Relaunch 19.09.2026:
 *  - Geldformat einheitlich deutsch „1.234,56 €“ über Intl de-DE (gleich in
 *    schnellauswahl.js und konfigurator.js). Runde Beträge im Fließtext („99 €“) laufen über
 *    rundGeld(); krumme Beträge fallen dort auf die volle Schreibweise zurück statt zu runden.
 *  - Die feste Kassen-Leiste am Handy trägt ebenfalls data-korb-summe und wird dadurch ohne
 *    eigene Logik mitgeführt.
 *  - Die Gratis-Zeile setzt nur cart.liquid. Fällt eine Position weg, wird neu geladen
 *    (location.reload unten) - das muss so bleiben, sonst stünde die Zeile falsch da.
 */
(function () {
  "use strict";

  var euro = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });
  function geld(cent) { return euro.format(cent / 100); }
  /* „99 €“ statt „99,00 €“ für Sätze; bei krummen Beträgen die volle Schreibweise */
  function rundGeld(cent) {
    return cent % 100 === 0 ? (cent / 100).toLocaleString("de-DE") + " €" : geld(cent);
  }

  function schuetzen(text) {
    return String(text == null ? "" : text)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function holeKorb() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (a) { if (!a.ok) throw new Error("Warenkorb nicht erreichbar."); return a.json(); });
  }

  // Stufe 2a AP-04/AP-11: Hinzufügen nur nach ausdrücklichem Klick.
  var pfostenLaeuft = false;
  function legeInKorb(items) {
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: items }) }).then(function (antwort) {
      // Host-Fix 10.10.2026 (AP-04, Max): Shopify liefert /cart/add.js als text/javascript, auch mit Accept: application/json.
      // Deshalb Erkennung am Inhalt (JSON.parse), nicht am Content-Type, sonst wäre jeder gültige Korb-Klick ein Fehler.
      return antwort.text().then(function (text) {
        var daten;
        try { daten = JSON.parse(text); } catch (fehlerJson) { var e1 = new Error("keine JSON-Antwort"); e1.klartext = true; throw e1; }
        if (!antwort.ok) { var e2 = new Error(daten.description || daten.message || "Der Warenkorb hat die Position abgelehnt."); e2.vonShopify = true; throw e2; }
        return daten;
      });
    });
  }
  function aendereKorb(key, menge) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: menge })
    }).then(function (a) {
      return a.json().then(function (daten) {
        if (!a.ok) throw new Error(daten.description || daten.message || "Änderung abgelehnt.");
        return daten;
      });
    });
  }

  function zaehlerSetzen(anzahl) {
    document.querySelectorAll("[data-korb-zahl]").forEach(function (e) {
      e.textContent = anzahl;
      e.hidden = anzahl === 0;
      e.classList.remove("springt");
      void e.offsetWidth; /* Animation neu anstoßen */
      e.classList.add("springt");
    });
  }

  /* ---------- Bilder ----------
     Die Shopify-Produkte haben (noch) keine Produktbilder. Deshalb wird das Bild
     aus der Artikelnummer (SKU) abgeleitet und aus den Theme-Assets geholt -
     die Zuordnung liefert das Liquid als window.ROST_BILDER (Snippet bild-map).
     SKU-Aufbau muss zu produkte_bauen.py passen, z.B. ZF-656-1230-ANT-EIN. */
  var BILDER = window.ROST_BILDER || {};
  var FARBE_SLUG = { ANT: "anthrazit", MOO: "moosgruen", VER: "verzinkt", FEN: "fenstergrau" };

  /* Farbe einer Position aus ihren Konfigurations-Angaben lesen (für Positionen,
     deren SKU keine Farbe trägt, z.B. die Abdeckleiste AL-…). Liefert den Slug. */
  function farbeAusEigenschaften(eigenschaften) {
    if (!eigenschaften) return "";
    var text = Object.keys(eigenschaften).map(function (k) { return String(eigenschaften[k] || ""); }).join(" ");
    if (text.indexOf("Moosgrün") !== -1) return "moosgruen";
    if (text.indexOf("Verzinkt") !== -1) return "verzinkt";
    if (text.indexOf("Anthrazit") !== -1) return "anthrazit";
    return "";
  }

  function skuBild(sku, farbSlug) {
    if (!sku) return "";
    var t = String(sku).split("-");
    var schluessel = "";
    if (t[0] === "ZF") schluessel = "fence-" + t[1] + "-" + (FARBE_SLUG[t[3]] || "") + "-" + t[2];
    /* Abschluss- und Eckpfosten: echtes Einzelfoto in der Farbe aus der SKU
       (Standard-Ausführung Abdeckplättchen; die Abdeckleisten-Aufwertung hat
       ihre eigene AL-Position mit eigenem Bild) */
    else if (t[0] === "AP") schluessel = "pfosten-plaettchen-" + (FARBE_SLUG[t[3]] || "anthrazit");
    else if (t[0] === "EP") schluessel = "eckpfosten-plaettchen-" + (FARBE_SLUG[t[3]] || "anthrazit");
    /* Abdeckleiste: SKU trägt keine Farbe, die kommt aus den Eigenschaften;
       ohne Farbangabe bleibt das Kombi-Bild als Rückfallebene */
    else if (t[0] === "AL") schluessel = farbSlug ? "pfosten-leiste-" + farbSlug : "eckpfosten";
    else if (t[0] === "TOR") schluessel = "gate-" + (t[1] === "MUL" ? "multi" : "basic") + "-" + (t[2] === "DOP" ? "doppel" : "einzel");
    else if (t[0] === "SS") schluessel = "sicht-" + (t[1] === "GER" ? "gerillt" : "genarbt") + "-" + (FARBE_SLUG[t[2]] || "");
    return BILDER[schluessel] || "";
  }

  /* ---------- Mini-Warenkorb (seitliches Fenster) ---------- */
  var fenster = document.querySelector("[data-mini-korb]");
  var hintergrund = document.querySelector("[data-mini-korb-hintergrund]");

  function bildAdresse(url, breite) {
    if (!url) return "";
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + breite;
  }

  function fensterFuellen(korb) {
    if (!fenster) return;
    var inhalt = fenster.querySelector("[data-mini-korb-inhalt]");
    var fuss = fenster.querySelector("[data-mini-korb-fuss]");
    if (!inhalt) return;
    if (!korb.items.length) {
      inhalt.innerHTML = '<p class="mini-korb-leer">Ihr Warenkorb ist leer.</p>';
      if (fuss) fuss.hidden = true;
      return;
    }
    inhalt.innerHTML = korb.items.map(function (p) {
      var quelle = (String(p.sku || "").indexOf("ZF-") === 0 && skuBild(p.sku)) || (p.image ? bildAdresse(p.image, 120) : skuBild(p.sku, farbeAusEigenschaften(p.properties)));
      var bild = quelle
        ? '<img src="' + schuetzen(quelle) + '" alt="" loading="lazy" width="60" height="60">'
        : '<span class="mini-korb-bild-leer" aria-hidden="true"></span>';
      /* Ausführung (inkl. Farbe) je Position anzeigen, damit klar ist:
         geliefert wird alles in der gewählten Farbe */
      var ausfuehrung = p.variant_title && p.variant_title !== "Default Title"
        ? "<small>" + schuetzen(p.variant_title) + "</small>" : "";
      return '<div class="mini-korb-zeile">' + bild +
        '<div><strong>' + schuetzen(p.product_title) + "</strong>" + ausfuehrung +
        "<small>" + p.quantity + " × " + geld(p.final_price) + "</small></div>" +
        "<b>" + geld(p.final_line_price) + "</b></div>";
    }).join("");
    var summe = fenster.querySelector("[data-mini-korb-summe]");
    if (summe) summe.textContent = geld(korb.total_price);
    /* Umbau 08.10.2026: Gesamt mit Lieferung wie auf der Warenkorb-Seite. Lieferkosten und Freigrenze
       kommen als data-Attribute aus layout/theme.liquid (gleiche Regel wie cart.liquid). */
    var mkLieferung = parseInt(fenster.getAttribute("data-lieferung-cent"), 10) || 0;
    /* Kleinteile-Versand 09.10.2026: nur Zubehör im Korb = Paketversand (data-kleinteile-cent), Zwilling cart.liquid */
    var nurZubehoer = korb.items.length > 0 && korb.items.every(function (p) { return p.product_type === "Zubehör"; });
    var mkKlein = parseInt(fenster.getAttribute("data-kleinteile-cent"), 10) || 0;
    if (nurZubehoer && mkKlein > 0) mkLieferung = mkKlein;
    var mkArt = fenster.querySelector("[data-mini-korb-lieferart]");
    if (mkArt) mkArt.textContent = (nurZubehoer && mkKlein > 0 ? "Paketversand Zubehör" : "Lieferung deutschlandweit") + " (ab 2.000 € frei)";
    var mkFreiAb = parseInt(fenster.getAttribute("data-frei-ab-cent"), 10) || 0;
    var mkFrei = mkFreiAb > 0 && korb.total_price >= mkFreiAb;
    var mkL = fenster.querySelector("[data-mini-korb-lieferung]");
    if (mkL) mkL.textContent = mkFrei ? "kostenlos" : geld(mkLieferung);
    var mkG = fenster.querySelector("[data-mini-korb-gesamt]");
    if (mkG) mkG.textContent = geld(korb.total_price + (mkFrei ? 0 : mkLieferung));
    var mkA = fenster.querySelector("[data-mini-korb-abholung]");
    if (mkA) mkA.textContent = geld(korb.total_price);
    /* Gratis-Beigabe wie auf der Warenkorbseite: nur mit Doppelstabmatte oder Komplettset im Korb.
       Handle-Liste aus data-zaun-handles (layout/theme.liquid), Zwilling von korb_zaun_handles in cart.liquid. */
    var zaunHandles = String(fenster.getAttribute("data-zaun-handles") || "").split(",");
    var hatZaun = korb.items.some(function (p) { return zaunHandles.indexOf(p.handle) !== -1; });
    if (hatZaun) inhalt.insertAdjacentHTML("beforeend", '<div class="mini-korb-gratis"><span class="korb-gratis-marke">Gratis</span>' +
      '<span>1× Farbspraydose passend zur Zaunfarbe und 1× Inbusschlüssel 5,5 mm. <b>0,00 €</b></span></div>');
    if (fuss) fuss.hidden = false;
  }

  function fensterOeffnen() {
    if (!fenster) return;
    fenster.classList.add("offen");
    fenster.setAttribute("aria-hidden", "false");
    if (hintergrund) hintergrund.hidden = false;
    document.body.classList.add("mini-korb-offen");
    holeKorb().then(function (korb) {
      fensterFuellen(korb);
      zaehlerSetzen(korb.items.length);
    }).catch(function () {
      var inhalt = fenster.querySelector("[data-mini-korb-inhalt]");
      if (inhalt) inhalt.innerHTML = '<p class="mini-korb-leer">Der Warenkorb konnte nicht geladen werden. <a href="/cart">Zur Warenkorb-Seite</a></p>';
    });
  }

  function fensterSchliessen() {
    if (!fenster) return;
    fenster.classList.remove("offen");
    fenster.setAttribute("aria-hidden", "true");
    if (hintergrund) hintergrund.hidden = true;
    document.body.classList.remove("mini-korb-offen");
  }

  if (fenster) {
    fenster.addEventListener("click", function (ereignis) {
      if (ereignis.target.closest("[data-mini-korb-zu]")) fensterSchliessen();
    });
    if (hintergrund) hintergrund.addEventListener("click", fensterSchliessen);
    document.addEventListener("keydown", function (ereignis) {
      if (ereignis.key === "Escape") fensterSchliessen();
    });
    /* Klick auf den Warenkorb-Knopf im Kopf öffnet das Fenster statt die Seite -
       außer auf der Warenkorb-Seite selbst. Ohne JavaScript bleibt es ein Link. */
    if (!document.querySelector("[data-korb-seite]")) {
      document.querySelectorAll("[data-mini-korb-oeffner]").forEach(function (knopf) {
        knopf.addEventListener("click", function (ereignis) {
          ereignis.preventDefault();
          fensterOeffnen();
        });
      });
    }
  }

  window.RostKorb = { oeffnen: fensterOeffnen, schliessen: fensterSchliessen, zaehler: zaehlerSetzen };

  /* ---------- Warenkorb-Seite: Mengen ändern ---------- */
  var seite = document.querySelector("[data-korb-seite]");
  if (seite) {
    function quittiert(h, menge) { try { return sessionStorage.getItem("zf-pfosten-ok-" + h.dataset.mattenSku + "-" + menge) === "ja"; } catch (e) { return false; } }
    function waechterSperren() {
      var gesperrt = pfostenLaeuft || !!seite.querySelector(".wartet");
      seite.querySelectorAll("[data-pfosten-dazu]").forEach(function (a) { a.classList.toggle("ist-gesperrt", gesperrt); if (gesperrt) a.setAttribute("aria-disabled", "true"); else a.removeAttribute("aria-disabled"); });
    }
    function waechterNeu(korb) {
      var matten = Object.create(null), pfosten = Object.create(null), hatSet = false;
      korb.items.forEach(function (a) {
        if ((a.handle || (a.product && a.product.handle) || "").indexOf("doppelstabmattenzaun-komplettset-") >= 0) hatSet = true;
        var t = (a.sku || "").split("-");
        if (t[0] === "ZF") matten[a.sku] = (matten[a.sku] || 0) + a.quantity;
        if ((t[0] === "AP" || t[0] === "EP") && a.quantity > 0) pfosten[t[2] + "-" + t[3]] = true;
      });
      seite.querySelectorAll("[data-pfosten-waechter]").forEach(function (h) {
        var m = matten[h.dataset.mattenSku] || 0, a = h.querySelector("[data-pfosten-dazu]"), text = h.querySelector("[data-pfosten-text]");
        h.dataset.menge = m;
        h.hidden = !m || hatSet || !!pfosten[h.dataset.hoehe + "-" + h.dataset.farbe] || quittiert(h, m);
        if (text) text.textContent = "Zu " + m + " " + (m === 1 ? "Matte" : "Matten") + " gehören " + (m + 1) + " Pfosten. Fehlen sie absichtlich?";
        if (a) { a.dataset.menge = m + 1; a.textContent = (m + 1) + " " + a.dataset.beschreibung; }
        var link = h.querySelector("[data-pfosten-konfigurator]"); if (link) { var url = new URL(link.href, window.location.href); url.searchParams.set("l", String(m * 2.5)); link.href = url.href; }
      });
      waechterSperren();
    }
    seite.querySelectorAll("[data-pfosten-waechter]").forEach(function (h) {
      h.hidden = quittiert(h, h.dataset.menge);
      var ok = h.querySelector("[data-pfosten-ok]"); if (ok) { ok.hidden = false; ok.addEventListener("click", function () { h.hidden = true; try { sessionStorage.setItem("zf-pfosten-ok-" + h.dataset.mattenSku + "-" + h.dataset.menge, "ja"); } catch (e) {} }); }
    });
    seite.addEventListener("click", function (e) {
      var a = e.target.closest("[data-pfosten-dazu]"); if (!a) return; e.preventDefault();
      if (pfostenLaeuft || seite.querySelector(".wartet") || a.getAttribute("aria-disabled") === "true") return;
      var menge = Number(a.dataset.menge), id = Number(a.dataset.variante); if (!Number.isSafeInteger(menge) || menge < 1 || !(id > 0)) return;
      pfostenLaeuft = true; waechterSperren();
      var h = a.closest("[data-pfosten-waechter]"), alt = h.querySelector("[data-pfosten-fehler]"); if (alt) alt.remove();
      legeInKorb([{ id: id, quantity: menge }]).then(function () { window.location.reload(); }).catch(function (fehler) {
        var p = document.createElement("p"); p.className = "korb-status fehler"; p.setAttribute("role", "alert"); p.setAttribute("data-pfosten-fehler", "");
        var link = seite.getAttribute("data-rz-telefon-link"), anzeige = seite.getAttribute("data-rz-telefon-anzeige");
        p.innerHTML = fehler.vonShopify ? "Das hat nicht geklappt: " + schuetzen(fehler.message) : "Das hat gerade nicht geklappt. Bitte laden Sie die Seite neu" + (link && anzeige ? ' oder rufen Sie uns an: <a href="tel:' + schuetzen(link) + '">' + schuetzen(anzeige) + '</a>' : '.');
        h.appendChild(p); pfostenLaeuft = false; waechterSperren();
      });
    });
    /* Platzhalter-Kästen durch Bilder aus den Theme-Assets ersetzen (die
       Shopify-Produkte selbst haben noch keine Bilder). Die Farbe steckt bei
       manchen Positionen nur in den Konfigurations-Angaben, deshalb einmal
       den Korb abrufen; klappt das nicht, bleibt die SKU als Rückfallebene. */
    var bildSetzen = function (zeile, quelle) {
      var platzhalter = zeile.querySelector(".korb-bild-leer");
      if (!platzhalter || !quelle) return;
      var bild = document.createElement("img");
      bild.src = quelle;
      bild.alt = "";
      bild.width = 88;
      bild.height = 88;
      bild.loading = "lazy";
      platzhalter.replaceWith(bild);
    };
    var leereZeilen = [];
    seite.querySelectorAll("[data-korb-zeile]").forEach(function (zeile) {
      // relaunch-2026-09-19: Doppelstabmatten zeigen die neue Darstellung aus dem Theme (Farbe, Stärke, Höhe aus der SKU),
      // solange am Produkt in Shopify noch die alte Strichzeichnung hängt.
      var sku = zeile.getAttribute("data-sku") || "";
      var vorhanden = zeile.querySelector("img");
      if (vorhanden && sku.indexOf("ZF-") === 0 && skuBild(sku)) vorhanden.src = skuBild(sku);
      if (zeile.querySelector(".korb-bild-leer")) leereZeilen.push(zeile);
    });
    if (leereZeilen.length) {
      holeKorb().then(function (korb) {
        leereZeilen.forEach(function (zeile) {
          var key = zeile.getAttribute("data-key");
          var artikel = korb.items.filter(function (p) { return p.key === key; })[0];
          var quelle = artikel
            ? (artikel.image ? bildAdresse(artikel.image, 176) : skuBild(artikel.sku, farbeAusEigenschaften(artikel.properties)))
            : skuBild(zeile.getAttribute("data-sku"));
          bildSetzen(zeile, quelle);
        });
      }).catch(function () {
        leereZeilen.forEach(function (zeile) {
          bildSetzen(zeile, skuBild(zeile.getAttribute("data-sku")));
        });
      });
    }
    var zeileAnwenden = function (korb, zeile, key) {
      var artikel = korb.items.filter(function (p) { return p.key === key; })[0];
      if (!artikel) {
        /* Position wurde entfernt: Seite neu laden. Die Entfernen-Links der übrigen
           Zeilen tragen Zeilennummern, die jetzt verschoben wären - nach dem Neuladen
           stimmen sie wieder. */
        window.location.reload();
        return;
      }
      var eingabe = zeile.querySelector('input[name="updates[]"]');
      if (eingabe) eingabe.value = artikel.quantity;
      var preis = zeile.querySelector("[data-zeilen-preis]");
      if (preis) preis.textContent = geld(artikel.final_line_price);
      var minusKnopf = zeile.querySelector("[data-menge-minus]");
      if (minusKnopf) minusKnopf.disabled = artikel.quantity <= 1;
      document.querySelectorAll("[data-korb-summe]").forEach(function (e) {
        e.textContent = geld(korb.total_price);
      });
      waechterNeu(korb);
      zaehlerSetzen(korb.items.length);
      /* stufe1-2026-09-13: Gesamt inkl. Lieferung und Abholung mitrechnen, sonst stehen nach +/- zwei Summen
         nebeneinander. Lieferkosten und Freigrenze kommen als data-Attribute aus cart.liquid. */
      var versand = document.querySelector(".korb-versand");
      if (versand) {
        var lieferung = parseInt(versand.getAttribute("data-lieferung-cent"), 10) || 0;
        var freiAb = parseInt(versand.getAttribute("data-frei-ab-cent"), 10) || 0;
        var frei = freiAb > 0 && korb.total_price >= freiAb;
        /* gleiche Schreibweise wie im Mini-Warenkorb: „kostenlos“ ab der Freigrenze, sonst der Betrag */
        var lb = versand.querySelector("[data-korb-lieferung-betrag]");
        if (lb) lb.textContent = frei ? "kostenlos" : geld(lieferung);
        /* Umbau 08.10.2026: dokumentweit, die Kassenleiste am Handy trägt den Gesamtbetrag ebenfalls */
        document.querySelectorAll("[data-korb-gesamt-lieferung]").forEach(function (g1) {
          g1.textContent = geld(korb.total_price + (frei ? 0 : lieferung));
        });
        /* Korb-Umbau 09.10.2026: Abholbetrag steht jetzt unter dem Kassen-Knopf, außerhalb von .korb-versand */
        var g2 = document.querySelector("[data-korb-gesamt-abholung]");
        if (g2) g2.textContent = geld(korb.total_price);
      }
    };

    var mengeAendern = function (zeile, menge) {
      if (zeile.classList.contains("wartet")) return;
      var key = zeile.getAttribute("data-key");
      zeile.classList.add("wartet");
      waechterSperren();
      aendereKorb(key, menge).then(function (korb) {
        zeile.classList.remove("wartet");
        zeileAnwenden(korb, zeile, key);
      }).catch(function () {
        /* Im Zweifel neu laden - dann stimmt die Anzeige garantiert wieder */
        window.location.reload();
      });
    };

    seite.addEventListener("click", function (ereignis) {
      var plus = ereignis.target.closest("[data-menge-plus]");
      var minus = ereignis.target.closest("[data-menge-minus]");
      if (!plus && !minus) return;
      ereignis.preventDefault();
      var zeile = ereignis.target.closest("[data-korb-zeile]");
      if (!zeile) return;
      var eingabe = zeile.querySelector('input[name="updates[]"]');
      var aktuell = Math.max(0, parseInt(eingabe && eingabe.value, 10) || 0);
      /* Minus bei Menge 1 entfernt die Position nicht - dafür gibt es den Entfernen-Knopf */
      if (minus && aktuell <= 1) return;
      mengeAendern(zeile, plus ? aktuell + 1 : aktuell - 1);
    });

    seite.addEventListener("change", function (ereignis) {
      var eingabe = ereignis.target.closest('input[name="updates[]"]');
      if (!eingabe) return;
      var zeile = eingabe.closest("[data-korb-zeile]");
      if (!zeile) return;
      mengeAendern(zeile, Math.max(0, parseInt(eingabe.value, 10) || 0));
    });

    /* Enter im Mengenfeld darf nicht das Formular abschicken (einziger
       Submit-Knopf ist "Zur Kasse") - stattdessen nur die Menge übernehmen */
    seite.addEventListener("keydown", function (ereignis) {
      if (ereignis.key !== "Enter") return;
      var eingabe = ereignis.target.closest('input[name="updates[]"]');
      if (!eingabe) return;
      ereignis.preventDefault();
      var zeile = eingabe.closest("[data-korb-zeile]");
      if (zeile) mengeAendern(zeile, Math.max(0, parseInt(eingabe.value, 10) || 0));
    });
  }
})();
